import { useMutation, useQueryClient } from "@tanstack/react-query";
import { postTradeProposalBundleSubmit } from "../request/postTradeProposalBundleSubmit";
import { keyMaker as allProposalsKeyMaker } from "./useGetProposals";
import { keyMaker as singleBundleKeyMaker } from "./useGetTradeProposalBundle";
import { keyMaker as allBundlesKeyMaker, TradeProposalBundleId, } from "./useGetTradeProposalBundles";
export { TradeProposalBundleId };
const useSubmitTradeProposalBundle = (config) => {
    const queryClient = useQueryClient();
    const mutation = useMutation({
        mutationFn: async (tradeProposalBundleId) => {
            if (config === null) {
                throw new Error("No auth config");
            }
            return postTradeProposalBundleSubmit(tradeProposalBundleId, config);
        },
        onSuccess: async (_response, input) => {
            await queryClient.invalidateQueries({
                queryKey: allBundlesKeyMaker(null),
            });
            await queryClient.invalidateQueries({
                queryKey: singleBundleKeyMaker(input),
            });
            await queryClient.invalidateQueries({
                queryKey: allProposalsKeyMaker(null),
            });
        },
    });
    return mutation.mutateAsync;
};
export default useSubmitTradeProposalBundle;
//# sourceMappingURL=useSubmitTradeProposalBundle.js.map